import {
    selectDoc, ajax, selectArr,
    event, removeClassAll, hasClass, addClass, removeClass, toggleClass
} from "../utils/utils";
import {initSlider} from "../helpers/service.slider";
import {modalQuickViewHtml} from "../helpers/service.markup";
import {PDP} from "./component.pdp";

const props = {
    pageContainer: selectDoc('#PageContainer'),
    category: selectDoc('#category-tag'),
    hiddenContainer: selectDoc('#pcp-hidden-container'),
    html: selectDoc('html')
}

const initQuickviewSet = (atc, modal, setHandle) => {
    let title = selectDoc('.main-content #pdp #toolbar .pdp-title');
    if(title) {
        let continueATC = document.createElement('button');
        continueATC.className = 'btn btn--product'
        continueATC.innerHTML = `Purchase Only ${title.innerText}`;
        atc.parentNode.insertBefore(continueATC, atc.nextSibling);
        event(continueATC, 'click', function (e) {
            e.preventDefault();
            selectDoc('#pdp #addToCart').click();
        })
    }

    let setTitle = selectDoc('#toolbar .pdp-title', modal);
    if(setTitle) {
        setTitle.innerText = `Upgrade to the ${setTitle.innerText.trim()}`
    }

    let slider = selectDoc('#slider #product-images-slider', modal);
    if(slider) {
        let continueSet = document.createElement('a');
        continueSet.className = 'btn--arrow view-set'
        continueSet.innerHTML = `View Set Details&nbsp;`;
        continueSet.href = `/products/${setHandle}`
        slider.appendChild(continueSet);
    }
}

const fetchParentProductData = async (parentHandle, modal) => {
    if (parentHandle) {
        return new Promise(resolve => {
            ajax('GET', "/products/" + parentHandle.value)
                .then(function (response) {
                    let data = JSON.parse(response);
                    if (data.status !== undefined) {
                        if (data.status === 200) {
                            props.hiddenContainer.innerHTML = data.response;
                            let tabs = selectDoc('#toolbar', props.hiddenContainer),
                                slider = selectDoc('#slider', props.hiddenContainer),
                                customData = selectDoc('#product-custom-data', props.hiddenContainer),
                                setsData = selectDoc('#set-products', props.hiddenContainer),

                                modalSlider = selectDoc('#slider', modal),
                                modalToolbar = selectDoc('#toolbar', modal),
                                modalCustomData = selectDoc('#product-custom-data', modal),
                                modalSetsData = selectDoc('#set-products', modal);

                            modalSlider.innerHTML = slider.innerHTML;
                            modalSlider.className = 'col col-sm-6 col-md-half col-lg-6';
                            modalToolbar.innerHTML = tabs.innerHTML;
                            modalToolbar.className = 'col col-sm-6 col-md-half col-lg-6';
                            modalCustomData.innerHTML = customData.innerHTML;

                            if(setsData) {
                                modalSetsData.innerHTML = setsData.innerHTML
                            }

                            //Remove elements
                            let product3d = selectDoc('#slide-product3d', modalSlider);
                            if(product3d) {
                                product3d.parentNode.removeChild(product3d);
                            }
                            let hand3d = selectDoc('#slide-hand3d', modalSlider);
                            if(hand3d) {
                                hand3d.parentNode.removeChild(hand3d);
                            }

                            //Add elements
                            let atcForm = selectDoc('.shopify-product-form', modalToolbar),
                                atc = selectDoc('#addToCart', modalToolbar);
                            if(atc) {
                                if(!hasClass(modal, 'set')) {
                                    let atcHtml = atc.outerHTML;
                                    atc.parentNode.removeChild(atc);

                                    atcForm.innerHTML += `<div class="toolbar-modal-bottom">
                                                        ${atcHtml}
                                                        <a href="/products/${parentHandle.value}" class="goto-product btn--arrow">See Product Details&nbsp;</a>
                                                      </div>`;
                                } else {
                                    initQuickviewSet(atc, modal, parentHandle.value);
                                }
                            }

                            props.hiddenContainer.innerHTML = '';
                            resolve(true);
                        }
                    }
                })
        })
    }
}

const initTabs = (shopifyId, subCategory, modal, openQuickView) => {
    let handle = selectDoc(`#parent-handle-${shopifyId}`);
    fetchParentProductData(handle, modal)
        .then(function (response) {
            if(response) {
                addClass(modal, handle.getAttribute('data-type'));
                addClass(modal,'initiated');
                new PDP( `#qv-product-modal-${shopifyId}`, true);
                removeClass(openQuickView, 'loading');
                openQuickView.disabled = false;

                /**
                 * ADA
                 */
                let btn = selectDoc('form button', modal);
                btn.focus();
                btn.style.border = 'red solid 10px';
            }
        });
}

/**
 *
 * @param className
 */
const initModals = (className = '') => {
    selectArr('#category-products .product:not(.evented)').map(product => {
        addClass(product, 'evented');

        /**
         * Open modal
         */
        let openQuickView = selectDoc(`#quickview-${product.id.replace('prod-', '')}`);
        if (openQuickView) {
            event(openQuickView, 'click', function (e) {
                openQuickView.classList.add('loading');
                openQuickView.disabled = true;
                e.preventDefault();

                if (!hasClass(product, 'qv-modal-ready')) {
                    let modal = document.createElement('div'),
                        shopifyId = product.id.replace('prod-', '');
                    /*handle = selectDoc(`#parent-handle-${shopifyId}`);*/
                    modal.id = `qv-product-modal-${shopifyId}`;
                    modal.className = `modal-container qv-modal ${className}`;
                    modal.innerHTML = modalQuickViewHtml();
                    selectDoc('#site-modals-container').appendChild(modal);
                    product.classList.add('qv-modal-ready');
                }

                try {
                    //Open modal
                    let modalId = `${openQuickView.id.replace('quickview', 'qv-product-modal')}`,
                        modal = selectDoc(`#${modalId}`),
                        opener = selectDoc(`#open-qv-${product.id.replace('prod-', '')}`);

                    let click = new Event('click', {bubbles: true, cancelable: true})
                    opener ? opener.dispatchEvent(click) : '';

                    if (modal) {
                        if (!hasClass(modal, 'initiated')) {
                            //Init modal tabs
                            initTabs(
                                product.id.replace('prod-', ''),
                                product.getAttribute('data-sc').toUpperCase(),
                                modal, openQuickView
                            );
                        } else {
                            removeClass(openQuickView,'loading');
                            openQuickView.disabled = false;
                        }
                    }
                } catch (e) {
                    console.log('Error fetching quickview product data.', e)
                }
            })
        }
    })
}

export const QuickView = {
    init: (className = '') => initModals(className),
    props: props
}
